
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface BlogSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const BlogSearchBar = ({ searchTerm, setSearchTerm }: BlogSearchBarProps) => {
  return (
    <div className="max-w-3xl mx-auto mb-12">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-joerg-400 h-5 w-5" />
        <Input
          type="search"
          placeholder="Artikel suchen..."
          className="pl-10"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>
  );
};

export default BlogSearchBar;
